import React, { useState } from "react";
import back from "../assets/images/linkimage.png";
import icon1 from "../assets/images/linicon1.png";
import icon2 from "../assets/images/linicon2.png";
import arrow from "../assets/images/arrow.svg";
import Modal from "react-modal";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0px",
    borderRadius: "8px",
    border: "1px solid rgb(53, 53,53)",
    zIndex: "999",
    width:"90%"
  },
};

const Link = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="linksContainer">
      <div className="links">
        <h1  data-aos="fade-up"
     data-aos-duration="2000">دسترسی راحت برای خرید</h1>
        <div className="linkContainer">
          <div className="linkTitle">
            <img src={icon1} alt="link icon" loading="lazy"/>
            مراجعه حضوری به شعب
          </div>
          <a onClick={setModalOpen}>
     
            لینک فروشگاه‌های پاکشوما <img src={arrow} alt="arrow icon" loading="lazy"/>
          </a>
        </div>
        <div className="linkContainer">
          <div className="linkTitle">
            <img src={icon2} alt="link icon" loading="lazy"/>
            خرید از فروشگاه آنلاین پاکشوما
          </div>
          <a href="https://pakshoma.com/shop" target="blank">
     
            فروشگاه آنلاین پاکشوما <img src={arrow} alt="arrow icon" loading="lazy"/>
          </a>
        </div>
      </div>
      <img className="imgShop" src={back} alt="link back image" loading="lazy"/>

      <Modal isOpen={modalOpen} style={customStyles} contentLabel="Modal" onRequestClose={()=>setModalOpen(false)}>
        <div className="modalContainer">
          <iframe src={"https://mapbox.harmony.agency/pakshoma/"} width="100%" height="500px" title="Embedded content" frameBorder="0"></iframe>{" "}
        </div>
      </Modal>
    </div>
  );
};

export default Link;
